"use client";

import { sessionStore } from "@lib/sessionStore";
import { controlMissionToast } from "@lib/utils";
import { useToast } from "app/hooks";
import { usePathname } from "next/navigation";
import { useEffect, useState, useSyncExternalStore } from "react";

/**
 * ログイン時のミッション達成のトースター表示とregisterMissionするためのコンポーネント
 * @returns
 */
export function LoginMissionController() {
  const path = usePathname();
  const { pushToast } = useToast();
  const { sessionStatus, session, updateSession } = useSyncExternalStore(
    sessionStore.subscribe,
    sessionStore.getSnapshot,
    sessionStore.getServerSnapshot,
  );
  const [isDisplayed, setIsDisplayed] = useState(false);
  const [isMissionRegistered, setIsMissionRegistered] = useState(false);
  const [registerMissionRetryCount, setRegisterMissionRetryCount] = useState(0);
  //const { mutate: updateMissions } = useMissions(sessionStatus === "authenticated");

  useEffect(() => {
    if (isDisplayed) return;
    if (sessionStatus !== "authenticated") return;

    if (
      !session?.loginMissions ||
      !Array.isArray(session.loginMissions) ||
      session?.loginMissions.length === 0
    )
      return;
    if (path.includes("/auth")) return;
    if (!updateSession) return;

    controlMissionToast(session.loginMissions, pushToast, 500);

    setIsDisplayed(true);
    updateSession({ loginMissions: undefined });
  }, [sessionStatus, session, updateSession, path]);

  useEffect(() => {
    if (isMissionRegistered) return;
    if (sessionStatus !== "authenticated") return;
    if (registerMissionRetryCount > 2) return; // リトライ回数制限
    setIsMissionRegistered(true);
    setRegisterMissionRetryCount((prev) => prev + 1);
    fetch("/api/missions", {
      method: "POST",
    })
      .then((res) => {
        if (res.ok) {
          //ミッション登録直後にミッションを更新する必要がありそうならこちらとuseMissionsを有効に
          //updateMissions();
        }
      })
      .catch((err) => {
        //失敗した時はページ遷移時にリトライ
        setIsMissionRegistered(false);
      });
  }, [sessionStatus, path]);

  return <></>;
}
